import { forwardRef, useCallback, useMemo } from 'react';

import { Alert } from '@braskai/ui-kit';

import { AlertProps } from '@mui/material';
import { CustomContentProps, useSnackbar } from 'notistack';

import { AlertType } from '@/shared/types/Alert';

type AlertContainerProps = {
  variant?: AlertProps['severity'];
} & Omit<CustomContentProps, 'variant'>;

export const AlertContainer = forwardRef<HTMLDivElement, AlertContainerProps>(
  ({ id, action, className, message, style, variant = AlertType.Error }, ref) => {
    const { closeSnackbar } = useSnackbar();

    const messageElement = useMemo(() => {
      if (!message) {
        return '';
      }

      if (typeof message === 'string') {
        return message.split('\n').map((text, idx) => {
          return (
            <span key={text}>
              {idx ? <br /> : null}
              {text}
            </span>
          );
        });
      }

      return message;
    }, [message]);

    const handleDismiss = useCallback(() => {
      closeSnackbar(id);
    }, [id, closeSnackbar]);

    const resolvedAction = typeof action === 'function' ? action(id) : action;

    return (
      <Alert
        action={resolvedAction}
        className={className}
        ref={ref}
        severity={variant}
        style={style}
        onClose={handleDismiss}
      >
        {messageElement}
      </Alert>
    );
  },
);
